import { Box, Text, Table, Accordion } from '@chakra-ui/react';
import type { SurveyResponseGroup } from '../../types/contactDetail'

interface SurveyResponsesSectionProps {
  groups: SurveyResponseGroup[]
}

export function SurveyResponsesSection({ groups }: SurveyResponsesSectionProps) {
  if (groups.length === 0) {
    return (
      <Box bg="surface" p={8} borderRadius="lg" shadow="md" textAlign="center">
        <Text color="gray.500">No survey responses recorded.</Text>
      </Box>
    )
  }

  return (
    <Box bg="surface" borderRadius="lg" shadow="md" overflow="hidden">
      <Accordion.Root multiple defaultValue={groups[0] ? [groups[0].sessionId] : []}>
        {groups.map((group) => (
          <Accordion.Item
            key={group.sessionId}
            border="none"
            borderBottom="1px"
            borderColor="gray.100"
            value={group.sessionId}>
            <Accordion.ItemTrigger py={3} px={4} _hover={{ bg: 'gray.50' }}>
              <Box flex="1" textAlign="left">
                <Text fontSize="sm" fontWeight="medium">
                  {new Date(group.sessionDate).toLocaleDateString()}
                  <Text as="span" color="gray.500" fontWeight="normal" ml={2}>
                    by {group.canvasserName} ({group.responses.length} responses)
                  </Text>
                </Text>
              </Box>
              <Accordion.ItemIndicator />
            </Accordion.ItemTrigger>
            <Accordion.ItemContent pb={4} px={4}><Accordion.ItemBody>
                <Box overflowX="auto">
                <Table.Root size="sm" variant="line">
                  <Table.Header>
                    <Table.Row>
                      <Table.ColumnHeader>Question</Table.ColumnHeader>
                      <Table.ColumnHeader>Answer</Table.ColumnHeader>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {group.responses.map((r) => (
                      <Table.Row key={r.id}>
                        <Table.Cell>
                          <Text fontSize="sm" fontWeight="medium">{r.questionLabel}</Text>
                          <Text fontSize="xs" color="gray.500">{r.questionText}</Text>
                        </Table.Cell>
                        <Table.Cell fontSize="sm">{r.answerText || r.responseText || '-'}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table.Root>
                </Box>
              </Accordion.ItemBody></Accordion.ItemContent>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </Box>
  );
}
